export function formatBirthdayFromKennitala(kennitala: string) {
    let year = '19';
    if (kennitala.substring(9, 10) == '0') {
        year = '20';
    }
    year = year + kennitala.substring(4, 6);

    return kennitala.substring(2, 4) + '.' + kennitala.substring(0, 2) + '.' + year;
}
